import Vue from 'vue';
import { Component, Inject } from 'vue-property-decorator';
import BrochureCard from '@/common/interfaces/modules/BrochureCard';
import vSelect from 'vue-select';

import Dropdown from '@/components/Dropdown/Dropdown.vue';
import CtaButton from '@/components/CtaButton/CtaButton.vue';

import Pin from '@/assets/icons/pin-filled.svg?inline';

import CtaLinkItem, { CtaButtonStyle } from '@/common/interfaces/CtaLinkItem';

const BrochureCardProps = Vue.extend({
  props: { card: Object as () => BrochureCard },
});

@Component({
  components: {
    Pin,
    Dropdown,
    CtaButton,
    vSelect,
  },
})
export default class BrochureCardComponent extends BrochureCardProps {
  get buttons() {
    const orderButton: CtaLinkItem = {
      Title: 'Request Brochure',
      Link: this.card.OrderLink,
      ButtonStyle: CtaButtonStyle.PrimaryDarkBlack,
    };
    const viewButton: CtaLinkItem = {
      Title: 'View online',
      Link: this.card.BrochureLink,
      ButtonStyle: CtaButtonStyle.White,
    };
    const pdfButton: CtaLinkItem = {
      Title: 'Download Brochure',
      Link: this.card.PdfLink,
      ButtonStyle: CtaButtonStyle.PrimaryDarkBlack,
    };

    return { orderButton, viewButton, pdfButton };
  }

  qtyOptions = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  @Inject()
  updateQuantity!: (brochureId: number, qty: number) => void;

  qtyChanged(qty: number) {
    this.updateQuantity(this.card.Id, qty);
  }

  destroyed() {
    this.updateQuantity(this.card.Id, 0);
  }

  mounted() {
    let ifPointer = window.matchMedia('(pointer:fine)').matches;
    let brochureCards = document.querySelectorAll('.brochure-card');
    brochureCards.forEach((card) => {
      let brochureButtons = card.querySelectorAll('.brochure-card__button');
      let image = <HTMLElement>card.querySelector('.brochure-card__image');
      brochureButtons.forEach((button) => {
        button.addEventListener('mouseenter', () =>
          ifPointer ? (image.style.transform = 'scale(1.05)') : null,
        );
        button.addEventListener('mouseleave', () =>
          ifPointer ? (image.style.transform = 'scale(1)') : null,
        );
      });
    });
  }

  onDownloadClick($event: Event) {
    this.$parent.$parent.$parent.$emit('onDownloadClick', $event, this.card.PdfLink)
  }
}
